import dayjs from 'dayjs';

import ApiService from './Api.service';

export type ReportType = 'par' | 'audit';

type ReportingServiceBodyDto = {
  endDate: string;
  planIds: number[];
  reportType: ReportType;
  startDate: string;
  tpaId: number;
};

export class ReportingService {
  static async getSigmaUrl(
    planIds: Array<number>,
    dateRange: object,
    reportType: ReportType,
    tpaId: number
  ): Promise<string> {
    try {
      const sigmaUrl = await ApiService.postJson<
        ReportingServiceBodyDto,
        string
      >(`/reporting`, {
        endDate: dayjs(dateRange[1]).format('YYYY-MM-DD'),
        planIds,
        reportType,
        startDate: dayjs(dateRange[0]).format('YYYY-MM-DD'),
        tpaId
      });

      if (!sigmaUrl) {
        throw new Error(`Unable to generate Sigma URL`);
      }

      return sigmaUrl;
    } catch (error) {
      throw new Error(`Unable to generate Sigma URL: ${error.message}`);
    }
  }

  private static getFileName(reportType: ReportType): string {
    const date = new Date().getTime();
    return `sigma-report-${reportType}-${date}.csv`;
  }

  static async downloadSigmaReport(
    dateRange: object,
    reportType: ReportType,
    tpaId: number
  ) {
    try {
      const response = await ApiService.getArrayBufferWithHeaders(
        `/reporting/download`,
        {
          endDate: dayjs(dateRange[1]).format('YYYY-MM-DD'),
          reportType,
          startDate: dayjs(dateRange[0]).format('YYYY-MM-DD'),
          tpaId
        }
      );

      const contentType = response.headers['content-type'];
      let fileName = this.getFileName(reportType);

      if (
        contentType === 'application/zip' ||
        contentType === 'application/x-zip-compressed'
      ) {
        fileName = fileName.replace('.csv', '.zip');
      }

      const blob = new Blob([response.data], { type: contentType });
      const urlBlob = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = urlBlob;
      a.download = fileName;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(urlBlob);
    } catch (error) {
      throw new Error(`Unable to download Sigma report: ${error.message}`);
    }
  }
}
